
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IBeverage } from 'app/models/beverage';
import { ILocation } from 'app/models/location';
import { ISoftUpdate } from 'app/models/softUpdate';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule
]
})
export class FormComponent implements OnChanges {


  @Input() item!: ILocation;
  @Input() uid!: string;
  @Output() softUpdateLocation = new EventEmitter<ISoftUpdate<ILocation>>();


  form = this.fb.group({
    name: ['', { validators: [Validators.required] }],
    descr: ['',],
  });

  constructor(private fb: FormBuilder) { }



  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['item']?.currentValue) {
      this.patchFormFromItem(this.item);
    }
  }

  updateDescription() {
    if (this.item.id) {
      const update: Partial<ILocation> = {
        descr: this.form.controls.descr.value ?? ''
      };
      this.softUpdateCurrentBeverage(this.item.id, update);
    }
  }

  updateName() {
    if (this.item.id) {
      const update: Partial<ILocation> = {
        name: this.form.controls.name.value ?? ''
      };
      this.softUpdateCurrentBeverage(this.item.id, update);
    }
  }






  private softUpdateCurrentBeverage(locationId: string, item: Partial<ILocation>) {
    const update: ISoftUpdate<ILocation> = {
      id: locationId,
      data: item,
      uid: this.uid
    };
    this.softUpdateLocation.emit(update);

  }


  // #region FORM to ITEM
  private patchFormFromItem(item: ILocation) {

    this.form.patchValue({
      name: item.name,
      descr: item.descr,
    });
  }
  //#endregion FORM to ITEM


}
